import type { CSSProperties } from 'react';
import { vars } from '@/theme';

// Shared chrome for every SSO sign-in button. Lives in its own (component-free)
// module so both the login buttons and the network-admin NOVI editor can render
// at the EXACT same size — and so importing it doesn't disable Fast Refresh for
// the component file (react-refresh requires component-only exports).
export const ssoButtonStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 12,
  height: 44,
  width: '100%',
  padding: '0 16px',
  fontSize: 14,
  fontWeight: 500,
  fontFamily: "'Lato', sans-serif",
  border: '1px solid',
  borderColor: vars.color.surface.border,
  borderRadius: 0,
  backgroundColor: vars.color.fixed.white,
  color: vars.color.neutral.dark,
  cursor: 'pointer',
  transition: 'all 200ms',
  boxSizing: 'border-box',
};
